import { put } from '../../../infra/rest';
import { InvoiceWorkingPaginationArgs, GetInvoiceWorkingResponse } from '../typings';

const getInvoiceWorkingAPI = async (
  payoutCommissionId: string,
  paginationData?: InvoiceWorkingPaginationArgs
): Promise<GetInvoiceWorkingResponse> => {
  const url = '/v1/channel-partner/invoice-working';
  const response = await put<GetInvoiceWorkingResponse>(
    url,
    {
      body: JSON.stringify({
        invoiceId: payoutCommissionId,
        limit: 10,
        sortDirection: 'ASC',
      }),
    },
    true
  );

  return response;
};

export default getInvoiceWorkingAPI;
